import { useMemo } from 'react';

import { useQuery } from '@apollo/client';

import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import LearnerProfileDesiredSkills from 'bundles/onboarding-common/queries/LearnerProfileDesiredSkills.graphql';
import type {
  LearnerProfileDesiredSkillsQuery,
  LearnerProfileDesiredSkillsQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerProfileDesiredSkills';
import { formatSkillsWantedFromLearnerProfile } from 'bundles/onboarding-common/utils/savedQuestionDataUtils';

const useSkillsWantedData = ({ skip }: { skip?: boolean }) => {
  const { data, loading } = useQuery<LearnerProfileDesiredSkillsQuery, LearnerProfileDesiredSkillsQueryVariables>(
    LearnerProfileDesiredSkills,
    {
      context: { clientName: 'gatewayGql' },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
      skip,
    }
  );

  // Memoize the formatted value to prevent new references when data hasn't changed
  const value = useMemo(() => {
    return formatSkillsWantedFromLearnerProfile(data);
  }, [data]);

  return {
    value,
    loading,
    __typename: QUESTION_IDS.skillSelect,
  };
};
export default useSkillsWantedData;
